import 'isomorphic-fetch'
import * as $$BASE from '../actions/baseAction'
import * as $$USER from '../actions/userAction'
import * as USER_TYPE from '../constants/types/userTypes'
import $CACHE from '../helpers/cache'
import {DOMAIN, CLIENT_SOURCE, RUN_ENV} from '../constants/config'
import {Hex_MD5, getCookie} from '../helpers/unit'
import {setCookie} from '../helpers/unit';

window._FETCHING = {};

function checkStatus(response) {
    if (response.status === 200) {
        return response
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function request({url, method, data}, successCallback, errorCallback) {
    //(RUN_ENV == 'app' && process.env.NODE_ENV == 'production' && window.APP_DOMAIN ? window.APP_DOMAIN : DOMAIN)
    var request_url = DOMAIN + encodeURI(url);
    console.log(request_url);
    fetch(request_url, {
        credentials: 'include',
        method: method || 'GET',
        headers: {
            'Authorization': 'bearer ' + window.AUTH_TOKEN,
            'Content-Type': 'application/vnd.sc-api.v1.json',
            'Source': CLIENT_SOURCE[window.CLIENT_INFOS.source]
        },
        body: data ? JSON.stringify(data) : undefined
    })
        .then(checkStatus)
        .then(response => response.json())
        .then(successCallback)
        .catch(errorCallback);
}

// 生成请求 KEY
function uniqueFetch(url, method) {
    return Hex_MD5(url + method);
}

export default store => next => action => {

    if (!action.payload || !action.payload.url) {
        return next(action);
    }

    const {loading, cache, errorProcess, url, method, data} = action.payload;
    /**
     * _error_ : 错误时额外操作
     * _success_ : 成功时额外操作
     */
    const {type, _error_, _success_, _done_, ignoreError, _callbacks_} = action;

    // LS CACHE
    if (cache) {
        const _lsCache = $CACHE.get(cache.key);
        if (_lsCache) {
            // 成功额外后续
            if (_success_ && _success_.length > 0) {
                _.forEach(_success_, function (item, index) {
                    if (item.takeParam) {
                        store.dispatch(item.action(_lsCache, action))
                    } else {
                        store.dispatch(item.action)
                    }
                })
            }
            ;
            return next({
                type: type,
                result: {data: _lsCache.data},
                status: 0,
                request: action.payload,
                extend: action.extend,
                origin: action
            });
        }
        ;
    }
    ;

    // 唯一请求
    const requestUniqueKey = uniqueFetch(url, method);

    if (window._FETCHING[requestUniqueKey]) {
        return;
    } else {
        window._FETCHING[requestUniqueKey] = true;
    }

    // 后端防重复请求
    if (_.includes(['PUT', 'POST'], _.upperCase(method))) {
        data.nonce = Hex_MD5(requestUniqueKey + _.random(9999999) + Hex_MD5(JSON.stringify(data)));
    }

    // LOADING
    if (loading) {
        if (_.isObject(loading)) {
            store.dispatch($$BASE.openLoading(loading.text));
        } else {
            store.dispatch($$BASE.openLoading());
        }
    }
    ;

    return request({url, method, data},
        payload => {

            // 开发环境打印响应
            if ((window.MODEL == 'dev' || process.env.NODE_ENV == 'dev') && !DISABLE_HTTP_LOG) {
                console.group('#REQUEST LOG @DATE:' + new Date());
                console.info('#请求地址: ' + url);
                console.info('#请求方法: ' + method);
                console.info('#请求参数: ');
                console.log(data);
                console.info('#响应: ');
                console.log(payload);
                console.groupEnd();
            }

            // 关闭重复请求限制
            delete window._FETCHING[requestUniqueKey];

            // 服务器时间 滴答滴答 :)
            window.serverTime = payload.timestamp;
            if (window.serverClockTimer) {
                window.clearInterval(window.serverClockTimer)
            }
            window.serverClockTimer = window.setInterval(function () {
                window.serverTime++;
            }, 1000)

            // 关闭loading框
            if (loading) {
                store.dispatch($$BASE.closeLoading())
            }
            ;

            // 登录超时
            if (_.includes([20101, 20102, 20103, 20111], payload.status)) {
                if (!_.includes(window.location.href, '#/login')) {
                    next($$BASE.openAlert('登录超时，请重新登录'));
                    next($$BASE.showUI(0.3));
                    return next({type: USER_TYPE.LOGOUT});
                }
                ;
                return next({type: 'NOTHING_TO_DO'});
            }
            ;

            // 被踢下线
            if (payload.status == 20106) {
                if (!_.includes(window.location.href, '#/login')) {
                    next($$BASE.openAlert('账号已在其他地方登录，请重新登录'));
                    next( $$BASE.showUI(0.3) );
                    return next({type: USER_TYPE.LOGOUT});
                }
                return next({type: 'NOTHING_TO_DO'});
            }

            //禁止登陆
            if (payload.status == 20107) {
                if (!_.includes(window.location.href, '#/login')) {
                    next($$BASE.openAlert(payload.message));
                    next( $$BASE.showUI(0.3) );
                    return next({type: USER_TYPE.LOGOUT});
                }
                return next({type: 'NOTHING_TO_DO'});
            }

            // token登录时
            if (payload.data && payload.data.token) {
                window.AUTH_TOKEN = payload.data.token;
                window.AUTH_EXPIRESIN = payload.data.expires_in;
                setCookie('auth', payload.data.token, payload.data.expires_in);
                setCookie('auth-expires-in', payload.data.expires_in, payload.data.expires_in);
                store.dispatch($$USER.getSessionByToken(payload.data.token))
            }
            // TOKEN自动延期
            if (payload.authorization && payload.authorization.token) {
                window.AUTH_TOKEN = payload.authorization.token;
                window.AUTH_EXPIRESIN = payload.authorization.expires_in;
                setCookie('auth', payload.authorization.token, payload.authorization.expires_in);
                setCookie('auth-expires-in', payload.authorization.expires_in, payload.authorization.expires_in);
                store.dispatch($$USER.getSessionByToken(payload.authorization.token))
            }

            // 回调函数
            if (_callbacks_ && _callbacks_.length > 0) {
                _.forEach(_callbacks_, function(fn) {
                fn(payload, action);
                });
            }

            // 完成时
            if (_done_ && _done_.length > 0) {
                _.forEach(_done_, function (item, index) {
                    if (item.takeParam) {
                        store.dispatch(item.action(payload, action))
                    } else {
                        store.dispatch(item.action)
                    }
                })
            }

            // 业务错误
            if (payload.status != 10000) {
                if (_error_ && _error_.length > 0) {
                    _.forEach(_error_, function (item, index) {
                        if (item.takeParam) {
                            store.dispatch(item.action(payload, action))
                        } else {
                            store.dispatch(item.action)
                        }
                    })
                }
                ;
                if (ignoreError) {
                    return next({type: 'NOTHING_TO_DO'});
                } else {
                    const errorsMsg = payload.errors ? _.chain(payload.errors).values().join('<br/>').value() : payload.message;
                    return next($$BASE.openAlert(errorsMsg));
                }
            }
            ;

            // 缓存
            if (cache) {
                $CACHE.put(cache.key, payload.data, cache.expires);
            }
            ;

            // 成功额外后续
            if (_success_ && _success_.length > 0) {
                _.forEach(_success_, function (item, index) {
                    if (item.takeParam) {
                        store.dispatch(item.action(payload, action))
                    } else {
                        store.dispatch(item.action)
                    }
                })
            }
            ;

            // DISPATCH TYPE
            return next({type: type, result: payload, request: action.payload, extend: action.extend, origin: action});
        },
        error => {
            window.setTimeout(function () {
                const requestUniqueKey = uniqueFetch(action.payload.url, action.payload.method);
                delete window._FETCHING[requestUniqueKey];
            }, 500)
            if (loading) {
                store.dispatch($$BASE.closeLoading())
            }
            if(process.env.RUN_ENV == 'app'){
                store.dispatch( $$BASE.openToast('网络异常,请求失败',null,3));
            }
            if (process.env.NODE_ENV === 'production') {
                // next( $$BASE.openAlert('出错了，请刷新') );
                console.log(error);
            }
        })
}
